import { render } from "./ResellerCompanies.vue?vue&type=template&id=02f85874"
import script from "./ResellerCompanies.vue?vue&type=script&lang=js"
export * from "./ResellerCompanies.vue?vue&type=script&lang=js"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__